import getPaymentsWithId from './getPaymentsWithId.js';
import debugWallet from './debugWallet.js';
async function syncWithWalletStorage(_ref) {
  let {
    action,
    walletStorageService,
    paymentInfo,
    isManualSync
  } = _ref;
  const walletId = paymentInfo?.walletId;
  debugWallet(`WalletId: ${walletId}`, paymentInfo, ` action: ${action}`);
  if (walletStorageService) {
    const paymentsFromStorage = walletId ? await walletStorageService.getDataWithWalletId() : {
      statusCode: 404
    };
    if (paymentsFromStorage?.statusCode === 404) {
      // The Wallet Id in Local Storage isn't valid
      // delete it from paymentInfo and repeat the process
      // so we can get a valid id from Wallet Central or create a new id
      delete paymentInfo.walletId;
      return {
        paymentInfo
      };
    }

    // compare to see which has the latest info
    const lastUpdatedCache = walletStorageService.getWalletLastUpdated();
    if (!isManualSync && walletId && paymentsFromStorage?.paymentInfo?.lastUpdated?.toString() === lastUpdatedCache) {
      const updatedPaymentsFromStorage = {
        ...paymentsFromStorage,
        paymentInfo: {
          ...paymentsFromStorage?.paymentInfo,
          interactions: {
            ...paymentsFromStorage?.paymentInfo?.interactions,
            syncAlert: null // do not display sync alert if the data is latest since the last visit
          }
        }
      };
      return updatedPaymentsFromStorage;
    }
    if (isManualSync || (paymentsFromStorage?.paymentInfo?.lastUpdated || 0) > (lastUpdatedCache || 0)) {
      // if wallet storage has the latest
      return getPaymentsWithId({
        paymentInfo: paymentsFromStorage?.paymentInfo,
        walletId,
        // show success message if wallet was ever used/updated in wallet storage
        showSyncAlert: paymentsFromStorage?.paymentInfo?.lastUpdated > 0,
        isManualSync
      });
    }

    // return data from Wallet Storage
    return paymentsFromStorage;
  }
  return {
    paymentInfo
  };
}
export { syncWithWalletStorage as default };
